// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WarningAlert: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M18.331 18c1.28 0 2.085-1.406 1.444-2.53L11.444.842a1.657 1.657 0 0 0-2.888 0L.225 15.47C-.415 16.592.386 18 1.669 18H18.33Zm-7.488-6.188H9.157a.419.419 0 0 1-.416-.398l-.257-4.782a.42.42 0 0 1 .416-.445h2.2a.42.42 0 0 1 .416.445l-.257 4.782a.419.419 0 0 1-.416.398ZM10 15.68a1.607 1.607 0 0 1-1.597-1.618c0-.893.715-1.617 1.597-1.617s1.597.724 1.597 1.617c0 .894-.715 1.618-1.597 1.618Z"
            />
        </svg>
    );
};

export default React.memo(WarningAlert);
